import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@core/modals/modal-registry.token';
import { UpgraderDepositModalComponent } from '@features/games/upgrader/modals/upgrader-deposit-modal/upgrader-deposit-modal.component';

export function provideUpgraderModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'UpgraderDepositModal', component: UpgraderDepositModalComponent, requiresAuth: true }, multi: true },
  ];
}
